import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";
import { articles } from "@/mocks/articles";

export default function ArticlesPage() {
  const canonical = "https://ribenhanou-style.com/articles";
  const pageTitle = "潮流文章 - 日韩欧美穿搭指南与趋势解读";
  const pageDesc =
    "阅读最新日韩欧美潮流文章，涵盖穿搭指南、趋势解读、单品推荐和购物攻略。日系清新、韩系时尚、欧美大气、美式随性，全方位时尚资讯尽在日韩欧美 Style Hub。";

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        name: pageTitle,
        description: pageDesc,
        url: canonical,
        isPartOf: { "@type": "WebSite", name: "日韩欧美 Style Hub" },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://ribenhanou-style.com/" },
          { "@type": "ListItem", position: 2, name: "潮流文章", item: canonical },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords="日韩欧美,日韩欧美潮流,日韩欧美风格穿搭,日韩欧美品牌推荐,日韩欧美时尚趋势,日韩欧美购物指南"
        canonicalUrl={canonical}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="w-full px-4 md:px-6 py-6 md:py-8 bg-background-100">
          <Breadcrumb
            items={[
              { label: "首页", to: "/" },
              { label: "潮流文章" },
            ]}
          />
          <div className="max-w-7xl mx-auto mt-4 md:mt-6">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              潮流文章
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
              最新日韩欧美穿搭指南、趋势解读和时尚灵感，助你掌握国际潮流脉搏
            </p>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group cursor-pointer bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300 transition-all duration-200"
                >
                  <div className="relative overflow-hidden aspect-[16/10]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2 text-xs text-foreground-500">
                      <span>{article.date}</span>
                      <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                      <span>{article.readTime}阅读</span>
                      <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                      <span>{article.author}</span>
                    </div>
                    <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-800 rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}